export class Languages
{
    public  LanguageID : Number;
    public  LanguageName : string;
}